import { RetrieveCartResponse } from '@aglenergy/shared-library';
import { AddressDetailModel } from 'app/shared/models/address/address.model';
import { ProductSearchRequestModel } from 'app/shared/models/productSearchRequestModel';

export const isSameAddress = (currentRequest: ProductSearchRequestModel, searchRequest: ProductSearchRequestModel): boolean => {
  const baseProductCategoriesToSearch = currentRequest?.productCategoriesToSearch?.join('');
  const requestProductCategoriesToSearch = searchRequest?.productCategoriesToSearch?.join('');

  return (
    currentRequest?.unitNumber === searchRequest?.unitNumber &&
    currentRequest?.streetNumber === searchRequest?.streetNumber &&
    currentRequest?.streetName === searchRequest?.streetName &&
    currentRequest?.streetType === searchRequest?.streetType &&
    currentRequest?.streetTypeSuffix === searchRequest?.streetTypeSuffix &&
    currentRequest?.suburb === searchRequest?.suburb &&
    currentRequest?.state === searchRequest?.state &&
    currentRequest?.postcode === searchRequest?.postcode &&
    currentRequest?.webCampaignId === searchRequest?.webCampaignId &&
    baseProductCategoriesToSearch === requestProductCategoriesToSearch
  );
};

export const getAddressFromCart = (cart: RetrieveCartResponse): AddressDetailModel => {
  const itemWithAddress = cart?.cartItems?.find((item) => !!item.additionalData?.productQualification?.siteAddress);
  const itemAddress = itemWithAddress?.additionalData?.productQualification?.siteAddress;
  if (!itemAddress) {
    return null;
  }
  return {
    unitNumber: itemAddress.unitNumber ?? '',
    streetNumber: itemAddress.streetNumber,
    streetName: itemAddress.streetName,
    streetType: itemAddress.streetType,
    streetTypeSuffix: '',
    suburb: itemAddress.suburb,
    state: itemAddress.state,
    postcode: itemAddress.postcode
  };
};
